import script from "./VideoScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoScroll.vue?vue&type=script&setup=true&lang=js"

import "./VideoScroll.vue?vue&type=style&index=0&id=a6e9eec8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6e9eec8"]])

export default __exports__